import { inject } from '@angular/core';
import { CanMatchFn, Route, UrlSegment, Router, UrlTree } from '@angular/router';
import { map, take } from 'rxjs/operators';
import { AuthService } from '../services/auth.service';
import { AccessControlService } from '../services/access-control.service';

export const RedirectAuthedToHomeGuard: CanMatchFn = (_r: Route, _s: UrlSegment[]) => {
  const auth = inject(AuthService);
  const ac = inject(AccessControlService);
  const router = inject(Router);

  return auth.isAuthenticated$.pipe(
    take(1),
    map((isAuth) => {
      if (!isAuth) return true;

      const profile = auth.currentUserProfile;
      const role = (profile?.role ?? '').toString().trim().toLowerCase();

      // Hard requirement: SuperAdmin/SupportAdmin home is /user-management (never /dashboard)
      const defaultHome = role === 'superadmin' || role === 'supportadmin' ? '/user-management' : '/dashboard';

      const dest = ac.homeFor(profile, defaultHome);
      return router.parseUrl(dest ?? defaultHome) as UrlTree;
    }),
  );
};
